import Vue from 'vue'
import Vuex from 'vuex'
import delivery from './modules/delivery/delivery'
import common from './modules/common'
import cart from './modules/cart/cart'
import user from './modules/user/user'
import events from './modules/events'
import product from './modules/product/product'

import search from '@vendor/smukm/search/vuejs/store/search'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        delivery,
        common,
        cart,
        user,
        events,
        product,
        search
    }
})
window.VueStore = store; // для доступа из jquery
export default store
